import api from './axios';

export interface User {
  id: string;
  username: string;
  role: string;
  email?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface UserFormData {
  username: string;
  password?: string;
  confirmPassword?: string; // Added for password confirmation
  role: string;
  email: string; // Changed from optional to required
}

export interface PasswordChangeData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

const userService = {
  // Get all users (admin only)
  getAllUsers: async (): Promise<User[]> => {
    const response = await api.get('/api/users');
    return response.data;
  },

  // Get user by ID (admin only)
  getUserById: async (id: string): Promise<User> => {
    const response = await api.get(`/api/users/${id}`);
    return response.data;
  },

  // Create new user (admin only)
  createUser: async (userData: UserFormData): Promise<User> => {
    const response = await api.post('/api/users', userData);
    return response.data;
  },

  // Update user (admin only)
  updateUser: async (id: string, userData: UserFormData): Promise<User> => {
    const response = await api.put(`/api/users/${id}`, userData);
    return response.data;
  },

  // Delete user (admin only)
  deleteUser: async (id: string): Promise<void> => {
    await api.delete(`/api/users/${id}`);
  },

  // Change password (any authenticated user)
  changePassword: async (passwordData: PasswordChangeData): Promise<void> => {
    await api.post('/api/users/change-password', passwordData);
  },

  // Get current user profile
  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/api/users/profile');
    return response.data;
  }
};

export default userService; 